import Vue from 'vue';
import Component from 'vue-class-component';
import * as i18next from 'i18next';
import router from 'src/router';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountConfirmemailComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    confirmEmailLoading: boolean = true;
    confirmEmailError: boolean = false;

    mounted() {
        if (this.$route.query.token) {
            this.$auth.confirmEmail(this.$route.query.token as string)
                .then((result: boolean) => {
                    this.confirmEmailLoading = false;

                    if (result) {
                        router.push('/account');
                    } else {
                        this.confirmEmailError = true;
                    }
                })
                .catch(() => {
                    this.confirmEmailLoading = false;
                    this.confirmEmailError = true;
                });
        } else {
            window.location.href = '/';
        }
    }
}
